/**
 * What the sheet is currently showing — SPEC.md §3, CONTEXT.md.
 *
 * Exactly one of four at any moment. `empty` deliberately covers both the
 * untouched editor and a failed render with no last good render behind it:
 * in both cases there is nothing on the sheet, and the error card (not the
 * status bar) is what says why.
 */
export type PreviewState = 'empty' | 'drawing' | 'drawn' | 'stale';

/** The status bar's label for each state. Sentence case, per §9's copy rules. */
export const PREVIEW_STATE_LABEL: Record<PreviewState, string> = {
  empty: 'Empty',
  drawing: 'Drawing',
  drawn: 'Drawn',
  stale: 'Stale',
};

/** The dot colour for each state — amber in progress, green success, pink error. */
export const PREVIEW_STATE_DOT: Record<PreviewState, string> = {
  empty: 'text-ink-4',
  drawing: 'text-amber',
  drawn: 'text-green',
  stale: 'text-pink',
};
